import {
  LOAD_USER_INFO,
  SALE_UPDATE,
  // CREATE_ORDER,
  UPDATE_NOW_TIME,
  LOAD_QR_CODE,
  LOAD_DK_BUY_INFO
} from './mutation-types.js'
import {  now, text2time } from '../common/utils.js';

export default {
  //获取用户信息存入vuex
  [LOAD_USER_INFO](state, info) {
    if (info.uid > 0) {
      state.userInfo = { ...info
      }
      state.stageLevel = info.stageLevel
    } else {
      state.userInfo = null
      state.stageLevel = null
    }
  },
  //获取售卖存入vuex
  [SALE_UPDATE](state, info) {
    state.saleType = info.saleType
    state.goodsMap = info.goodsMap
    state.preMap = info.preMap
    state.lastMap = info.lastMap
    state.canGoodsIds = info.canGoodsIds
    state.buyInfos = info.buyInfos
    state.subId = +info.subId

    // 预售结束
    const PRE_END = text2time(info.sale20181111PreEnd)
    if(PRE_END > 0) {
      state.PRE_END = PRE_END
    }
    // 尾款开始
    const LAST_BEGIN = text2time(info.sale20181111Begin)
    if(LAST_BEGIN > 0) {
      state.LAST_BEGIN = LAST_BEGIN
    }
    
    // state.sale20181111PreEnd = info.sale20181111PreEnd
    // state.sale20181111Begin = info.sale20181111Begin
  },
  [UPDATE_NOW_TIME](state) {
    state._now = now()
  },
  [LOAD_QR_CODE](state, info) {
    state.qrCode = info.url
  },
  [LOAD_DK_BUY_INFO](state, buyInfo) {
    state.dkBuyInfo = buyInfo

    // alert(JSON.stringify(buyInfo, null, 2))
  }
  // [CREATE_ORDER](state, info) {
  //   // alert(JSON.stringify(info))
  // }
}
